import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { UserRole } from '@/types/user';
import { Loader2 } from 'lucide-react';
import { SEO } from '@/lib/seo';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles?: UserRole[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
    const { isAuthenticated, isLoading, user } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="min-h-screen bg-background flex items-center justify-center">
                <div className="text-center">
                    <Loader2 className="w-10 h-10 animate-spin text-primary mx-auto mb-4" />
                    <p className="text-muted-foreground">جاري التحميل...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        // Redirect to login page with return URL
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check role-based access if allowedRoles is specified
    // User must have at least one of the allowed roles
    if (allowedRoles && user && !user.roles?.some(r => allowedRoles.includes(r))) {
        // Redirect to dashboard if user doesn't have any required role
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <>
            <SEO
                title="TRBD Dashboard"
                description="Internal TRBD operations dashboard."
                path={location.pathname}
                noindex
            />
            {children}
        </>
    );
}

